import { createBookingLogic } from './createBookingLogic';
import { fetchBookingLogic } from './fetchBookingLogic';

export const logic = [createBookingLogic, fetchBookingLogic];
